import React from 'react'
import TopImage from '../components/common/TopImage'
import NavBar from '../components/common/NavBarLargeScreen'
import Footer from '../components/common/Footer'

const VisitingHourPage = () => {
  return (
    <div>
        <NavBar/>
        <TopImage text="Visiting Hours"/>

        <div className="flex flex-col  mx-28 max-md:mx-5 my-20 max-md:my-8 items-start text-base  tracking-wide leading-6 text-black">
      <div className="text-2xl tracking-wide font-bold">Office Hours</div>
      <div className="flex gap-5 justify-between  mt-3 max-w-full w-[376px]">
        <div>
          To Meet the Principal:
          <br />
          To Deposit Fee :{" "}
        </div>
        <div>
          9:30 AM - 10:30 AM
          <br />
          9:00 AM - 01:00 PM
        </div>
      </div>
      <div className="self-stretch list-disc mt-8 w-full max-md:max-w-full">
        To meet the Class Teacher/Subject Teacher
        <br />
        <li>1:40 pm to 2:30 pm (Summer)</li>
        
        <li>2:30 pm to 3:00 pm (Winter)</li>
      </div>
      <div className="self-stretch font-bold mt-8 w-full leading-[150%] max-md:max-w-full">
        *Telephone calls for teachers during school hours will not be
        entertained.
      </div>
      <div className="mt-8 text-2xl tracking-wide max-md:max-w-full font-bold">NOTE</div>
      <div className="mt-3 list-disc max-md:max-w-full">
        <li>Every second Saturday is a holiday for the school.</li>
        
       <li> Every last school day of the month is a half day for the school.</li>
      </div>
    </div>
        <Footer/>
    </div>
  )
}

export default VisitingHourPage